/* global dataLayer */
var lodashUnescape = require("lodash/unescape");

/**
 * function to push data to the dataLayer, and add hash
 * @param {Object} data - data to push
 */
function hashPush(data) {
    if (data) {
        // remove the Cart panel data from the dataLayer in order to prevent duplicated objects
        if (data.event === "openMiniCart") {
            var cartPanelPos = dataLayer.findIndex((element) => element.pageType === data.pageType);
            if (cartPanelPos > -1) {
                dataLayer.splice(cartPanelPos, 1);
            }
        }
        if (data.eventTypes) {
            delete data.eventTypes;
        }
        if (data.selector) {
            delete data.selector;
        }
        if (data.pushTheDataInPDP) {
            delete data.pushTheDataInPDP;
        }
        if ((location.hash.indexOf(data.event + "cbt") == -1)) {
            dataLayer.push(data);
            var filtered = dataLayer.filter(ele => ele.event === "newsletterSubscription");
            if (filtered.length > 1) {
                var position = dataLayer.findIndex(element => element.event === "newsletterSubscription");
                dataLayer.splice(position, 1);
            }
        }
    }
}

/**
 * Parse the data object into json
 * @param {String} data
 * @returns {Object} jsonObject
 */
function parseJSON(data) {
    if (typeof data !== "string") {
        return data;
    } else if (!data.length) {
        // Returns an empty object if the data is empty.
        return {};
    }

    let parsedJson = {};
    try {
        parsedJson = JSON.parse(data);
    } catch (error) {
        // Handle cases of missing closing quote
        if (data.length > data.lastIndexOf("}")) {
            data = data.substring(0, data.lastIndexOf("}") + 1);
        }
        // eslint-disable-next-line quotes
        parsedJson = JSON.parse(data.replace(/'/gi, '"').replace(/\\"/, "'"));
    }
    return parsedJson;
}

/**
 * check data type and parse string into JSON
 * @param {Object} data - data to push
 */
function dataPush(data) {
    if ((typeof(data) === "string") && (data != "")) {
        if ((data != null) || (data != "null")) {
            data = parseJSON(lodashUnescape(data));
            hashPush(data);
        }
    } else if (data instanceof Array) {
        data.forEach(element => {
            hashPush(element);
        });
    } else {
        hashPush(data);
    }
}

module.exports = {
    hashPush: hashPush,
    parseJSON: parseJSON,
    dataPush: dataPush
};
